import React from 'react';
import { FlexBox, TabContent } from '@vp/swan';
import { Request } from '@99designs/graph-utils/types';
import { __ } from '@99designs/i18n';
import { CollaborationRequestCard } from '../components/CollaborationRequestCard';
import { DraftBriefs } from '../components/DraftBriefs';
import { Error } from '../components/Error';
import { JobCard } from '../components/JobCard';
import { PastProjects } from '../components/PastProjects';
import { ProjectsRequestCard } from '../components/ProjectsRequestCard';
import { CombinedProject } from '../hooks/useCombinedProjects';
import { DashboardEmptyState } from './DashboardEmptyState';

export function CombinedTabs({
    selectedTabId,
    currentRequests,
    pastRequests,
    draftRequests,
    projectsError,
    requestsError,
}: {
    selectedTabId: 'current' | 'past' | 'draft';
    currentRequests: CombinedProject[];
    pastRequests: CombinedProject[];
    draftRequests: Request[];
    projectsError?: Error;
    requestsError?: Error;
}) {
    switch (selectedTabId) {
        case 'current':
            return (
                <TabContent tabId="current">
                    {projectsError ? (
                        <Error />
                    ) : currentRequests.length > 0 ? (
                        <FlexBox flexDirection="column" gap="between-subsections">
                            {currentRequests.map((r) => {
                                if (r.type === 'Project') {
                                    return <ProjectsRequestCard key={r.value.id} {...r.value} />;
                                } else if (r.type === 'Collaboration') {
                                    return (
                                        <CollaborationRequestCard key={r.value.url} {...r.value} />
                                    );
                                } else if (r.type === 'Request') {
                                    return <JobCard key={r.value.id} request={r.value} />;
                                } else {
                                    return null;
                                }
                            })}
                        </FlexBox>
                    ) : (
                        <DashboardEmptyState state="current" />
                    )}
                </TabContent>
            );
        case 'past':
            return (
                <TabContent tabId="past">
                    {projectsError ? (
                        <Error />
                    ) : pastRequests.length > 0 ? (
                        <PastProjects requests={pastRequests} />
                    ) : (
                        <DashboardEmptyState state="past" />
                    )}
                </TabContent>
            );
        case 'draft':
            return (
                <TabContent tabId="draft">
                    {requestsError ? (
                        <Error />
                    ) : draftRequests.length > 0 ? (
                        <DraftBriefs requests={draftRequests} />
                    ) : (
                        <DashboardEmptyState state="draft" />
                    )}
                </TabContent>
            );
    }
}
